// Thin wrapper around GA4's gtag(). layouts/_partials/gs-analytics.html only
// defines window.gtag in production builds, and only when the visitor hasn't
// set Do Not Track — so every call here is a silent no-op in `hugo server`
// dev builds and for DNT visitors. The page's content_group (locale) is set
// on the config call and attached to these events automatically.

export function track(name: string, params: Record<string, unknown> = {}) {
    if (typeof window.gtag !== "function") {
        return;
    }

    window.gtag("event", name, params);
}

const SEARCH_IDLE_MS = 1500;
const SEARCH_MIN_LENGTH = 2;

// Pagefind search is fully client-side (no ?q= in the URL), so GA4's own
// site-search tracking never sees it. Sends one GA4-recommended "search"
// event per settled query — after SEARCH_IDLE_MS without typing — rather
// than one per keystroke, and never the same term twice in a row.
export function trackSearchInput(input: HTMLInputElement, location: string) {
    let timer: number | undefined;
    let lastSent = "";

    input.addEventListener("input", () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
            const term = input.value.trim();
            if (term.length < SEARCH_MIN_LENGTH || term.toLowerCase() === lastSent) {
                return;
            }

            lastSent = term.toLowerCase();
            track("search", { search_term: term, search_location: location });
        }, SEARCH_IDLE_MS);
    });
}
